import "./DataArtificialIntelligence.module.css";
import EnTete from "@/reusable_sections/Header";
import HeroService from "./sections/HeroService";
import DetailsduService from "./sections/DetailsduService";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function DataArtificialIntelligencePage() {
  return <div>
      <EnTete />
      <HeroService />
      <DetailsduService />
      <CallToAction />
      <Footer />
    </div>;
}